import React from 'react';

import { useTranslation } from 'react-i18next';

import { PromotionWinnerType } from '@types';

import { CupFilledIcon } from '@components/icons';

import * as Styled from './single-winner-card.styled';

type OwnProps = {
	winner: PromotionWinnerType;
};

const SingleWinnerCard: React.FC<OwnProps> = ({ winner }) => {
	const { t } = useTranslation('main');

	return (
		<Styled.Wrapper>
			<Styled.PlaceChip>{'1 ' + t('place')}</Styled.PlaceChip>
			<Styled.Participant>{t('participant')}</Styled.Participant>
			<Styled.Name>{winner.user_pm_id}</Styled.Name>
			<Styled.Prize>{t('prize')}</Styled.Prize>
			<Styled.Name>
				<Styled.CupIconWrapper>
					<CupFilledIcon />
				</Styled.CupIconWrapper>
				{winner.prize_name}
			</Styled.Name>
		</Styled.Wrapper>
	);
};

export default SingleWinnerCard;
